import * as React from "react";
import * as ReactModal from "react-modal";

import { IconClose, IconLogoHorizontal } from "@common/components/Atoms/Icons";
import Loading from "@common/components/Atoms/Loading";

interface ModalProps {
    children?: React.ReactNode;
    closeModal: () => void;
    isOpen: boolean;
    loading?: boolean;
    onAfterOpen?: () => void;
    onRequestClose?: () => void;
    shouldCloseOnOverlayClick?: boolean;
    title?: string;
    size?: string;
    className?: string;
    dataCy?: string;
}

export const Modal = (props: ModalProps) => {
    const classes = ["c-modal"];
    if (!!props.size) classes.push("c-modal--" + props.size);
    if (!props.size) classes.push("c-modal--sm");
    if (!!props.loading) classes.push("is-loading");
    if (!!props.className) classes.push(props.className);

    return (
        <ReactModal
            portalClassName="o-modal-portal"
            bodyOpenClassName="has-modal"
            isOpen={props.isOpen}
            onAfterOpen={props.onAfterOpen}
            onRequestClose={props.onRequestClose}
            closeTimeoutMS={0}
            contentLabel="Modal"
            ariaHideApp={false}
            className={{
                base: "c-modal__container",
                afterOpen: "is-open",
                beforeClose: "is-closing",
            }}
            overlayClassName={{
                base: classes.join(" "),
                afterOpen: "is-open",
                beforeClose: "is-closing",
            }}
            shouldReturnFocusAfterClose={false}
            shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
        >
            <div className="c-modal__header">
                {
                    <div
                        className="c-modal__title"
                        id="openModelTitle"
                        data-cy={`${props.dataCy}-title-header`}
                    >
                        {props.title}
                    </div>
                }
                <button className="c-modal__close" onClick={props.closeModal}>
                    <IconClose width={24} height={24} />
                </button>
            </div>
            <div className="c-modal__scroll">
                <div className="c-modal__content" data-cy={`${props.dataCy}-modal-content`}>{props.children}</div>
            </div>
            {props.loading && (
                <div className="c-modal__loading" id="modal-loading-overlay">
                    <Loading message="please wait" />
                </div>
            )}
        </ReactModal>
    );
};

export default Modal;
